import React from 'react';
import ReactDOM from 'react-dom';
import { injectIntl } from 'react-intl';

const RoundSpinner = (props) => {
	/*
	This component doesn't work anymore.
	It displays the elements in the DOM, but it doesn't animate anything and the elements are not visible.

	Replace the instances of this component with regular <Spinner /> components, instead.
	*/
	




	const fullscreen = props?.fullscreen ?? true;
	const autotranslate = props?.autotranslate ?? true;

	let opts = {
		lines:11, // The number of lines to draw
		length:10, // The length of each line
		width:2, // The line thickness
		radius:10, // The radius of the inner circle
		corners:1, // Corner roundness (0..1)
		rotate:43, // The rotation offset
		direction:1, // 1: clockwise, -1: counterclockwise
		color:(!fullscreen) ? '#000000' : '#FFFFFF', // #rgb or #rrggbb or array of colors
		speed:0.8, // Rounds per second
		trail:20, // Afterglow percentage
		shadow:false, // Whether to render a shadow
		hwaccel:true, // Whether to use hardware acceleration
		className:'spinner', // The CSS class to assign to the spinner
		zIndex:2e9, // The z-index (defaults to 2000000000)
		top:'50%', // Top position relative to parent
		left:'50%', // Left position relative to parent
	};

	opts = $.extend(opts, props?.data ?? {});
	
	const spinner = new Spinner(opts).spin();

	let message = false;
	if(props.children != undefined) {
		message = (autotranslate && typeof props.children == 'string') ? props.intl.formatMessage({ id:props.children }) : props.children;
	}

	if(!fullscreen) {
		return (
			<aside class="overlay forceVisible gui_pos_rel_important">
				<div
					class="spinner"
					role="progressbar"
					style={{
						marginLeft:'50%',
						position:'relative',
						height:'1px',
					}}
					dangerouslySetInnerHTML={{ __html:spinner.el.innerHTML}}
				/>

				{(message) && (
					<div
						style={{
							color:opts.color,
							marginTop:'40px',
						}}
						class="gui_center_aligned"
					>{message}</div>
				)}
			</aside>
		)
	}

	let element = document.getElementById('gui_spinner_root');
	if(element == null) {
		element = document.createElement('div');
		element.id = 'gui_spinner_root';
		document.body.appendChild(element);
		element = document.getElementById('gui_spinner_root');
	}

	return ReactDOM.createPortal(
		<aside class="overlay forceVisible loader_full">
			<div
				class="spinner"
				role="progressbar"
				style={{
					position:'absolute',
					width:'0',
					zIndex:'2000000000',
					left:'50%',
					top:'50%',
				}}
				dangerouslySetInnerHTML={{ __html:spinner.el.innerHTML}}
			/>

			{(message) && (
				<div
					style={{
						color:opts.color,
						marginTop:'40px',
					}}
					class="gui_center_aligned"
				>{message}</div>
			)}
		</aside>,
		element,
	);
}

export default injectIntl(RoundSpinner);